<template>
  <div v-if="!loader" id="bookReader">
      <div id="pagination">
        <i @click="zoom('o')" class="fas fa-search-plus"></i>
        <i @click="zoom('i')" class="fas fa-search-minus"></i>
        <i @click="move('r')" class="fa fa-arrow-right"></i>
        <input min="1" type="number" v-model="selectPage" />
        <i @click="move('l')" class="fa fa-arrow-left"></i>
      </div>
    <div id="mainReader">
      <pdf
        :class="{ CurrentPage: index == currentPage }"
        class="pages"
        :id="`page${index}`"
        v-for="index in numPages"
        :key="index"
        :src="src"
        :page="index"
        @click="currentPage = index"
      ></pdf>
    </div>
  </div>

  <Loader v-else />
</template>

<script>
import Loader from "@/components/loader.vue";
import pdf from "vue-pdf";

export default {
  components: {
    pdf,
    Loader
  },
  watch: {
    selectPage(newVal) {
      if (newVal == 0 || newVal == "") return;
      this.currentPage =
        Number(newVal) <= this.numPages ? Number(newVal) : this.numPages;

      setTimeout(() => {
        document
          .getElementById(`page${this.currentPage}`)
          .scrollIntoView({ behavior: "smooth" });
      });
    }
  },
  data() {
    return {
      scale:1,
      src: null,
      numPages: undefined,
      loader: true,
      currentPage: 1,
      selectPage: 1
    };
  },
  mounted() {
    this.src = pdf.createLoadingTask(this.$route.query.source);
    this.src.promise.then((pdf) => {
      let numPages = pdf.numPages;
      this.numPages = 0;
      let timer = setInterval(() => {
        if (this.numPages < numPages) {
          this.numPages++;
          setTimeout(() => {
            let page = document.getElementById(`page${this.numPages}`);
            page.addEventListener("click", () => {
              this.currentPage = Number(page.id.slice(4, page.id.length));
              this.selectPage = this.currentPage;
            });
          });
        } else {
          clearInterval(timer);
        }
      }, 500);
      this.loader = false;
    });
    // setTimeout(()=>{
    //   document.querySelectorAll('.disableLeft')[0].classList.remove("disableLeft")
    // },2000)
  },
  methods: {
    zoom(side){
      if(side=='i'){
        this.scale-=0.1;
        if(this.scale<0.3){
          this.scale=0.3
        }
      }else{
        
        this.scale+=0.1;
        if(this.scale>2.3){
          this.scale=2.3
        }
      }
      document.getElementById("mainReader").style.transform=`scale(${this.scale})`
    },
    move(side) {
      if (side == "r") {
        if (this.currentPage < this.numPages) {
          this.currentPage++;
        } else {
          this.currentPage == 1;
        }
      } else {
        if (this.currentPage > 1) {
          this.currentPage--;
        } else {
          this.currentPage = 1;
        }
      }
      document
        .getElementById(`page${this.currentPage}`)
        .scrollIntoView({ behavior: "smooth" });
      this.selectPage = this.currentPage;
      let current = document.querySelectorAll(".CurrentPage");
      if (current.length > 0) {
        current[0].classList.remove("CurrentPage");
      }
      document
        .getElementById(`page${this.currentPage}`)
        .classList.add("CurrentPage");
    }
  }
};
</script>
<style scoped>
.disableLeft {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
#bookReader {
  width: 99%;
  margin: 20px auto;
  box-shadow: 0 0 4px black;
  position: relative;
  height: 94vh;
  overflow: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
div#pagination {
  position: fixed;
  top: 5%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
.pages.CurrentPage {
  background: #003399;
}
div#pagination i {
  font-size: 20px;
  color: #003399;
  cursor: pointer;
}
#pagination .fa-search-minus{
  margin-right:5px;
  margin-left: 10px;
}
div#pagination input {
  text-align: center;
  width: 60px;
  background: #cdcdcdb5;
  margin: 0 10px;
  color: #003399;
  font-size: 18px;
}
div#pagination input[type="number"] {
  -moz-appearance: textfield;
}

div#pagination input::-webkit-outer-spin-button,
div#pagination input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

#mainReader {
  width: 100%;
  position: relative;
  height: 100%;
  background: black;
  overflow: auto;
}
#mainReader span {
  width: 47%;
  margin: auto;
  height: auto;
}
#mainReader::-webkit-scrollbar {
  width: 0em;
}

#leftReader {
  width: 20%;
  border-right: 1px solid gray;
  height: 100%;
  overflow: auto;
}
#leftReader span {
  padding: 5px;
  margin-bottom: 5px;
  cursor: pointer;
  border-bottom: 1px solid grey;
}
#leftReader::-webkit-scrollbar {
  width: 1em;
}

#leftReader::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

#leftReader::-webkit-scrollbar-thumb {
  background-color: #003399;
  outline: 1px solid #003399;
}

</style>
